import HeaderMain from "../comp/head-navs-main";
import ViewContent from "../comp/view-content";
import ViewDividerSmall from "../comp/view-divider-sm";
import ViewDividerMedium from "../comp/view-divider-md";
import ViewSectionName from "../comp/view-section-name";

import VaultDocsListModule from "../comp/vault-docs-list";

export default function Vault() {

  return (
    <>
      <HeaderMain />
      <ViewContent 
        content={
          <>

            <VaultDocsListModule />

            <ViewDividerMedium />
            <ViewDividerMedium />
          </>
        }
      />
    </>
  )
}